import { render } from "./InvoiceRichTextInput.vue?vue&type=template&id=184d4946"
import script from "./InvoiceRichTextInput.vue?vue&type=script&lang=js"
export * from "./InvoiceRichTextInput.vue?vue&type=script&lang=js"

import "./InvoiceRichTextInput.vue?vue&type=style&index=0&id=184d4946&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__